export default function WhatTypeSection() {
  const situations = [
    {
      icon: "ri-passport-line",
      title: "Urgent Passport Renewal",
      desc: "Your passport expired or is expiring and your trip is coming up. If you qualify for renewal by mail (DS-82), we can process your renewal in as little as 3 business days — no office visit required. This is our most common urgent request.",
      link: "/passport-services/fast-passport-renewal/",
      linkText: "Learn about Fast Passport Renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "Urgent New Passport",
      desc: "First-time applicant with an upcoming trip. You'll need to visit a passport acceptance facility for the DS-11 in-person step, then we take it from there. Our couriers hand-deliver to the agency for fastest possible processing.",
      link: "/passport-services/new-passport/",
      linkText: "Learn about New Passports",
    },
    {
      icon: "ri-error-warning-line",
      title: "Urgent Lost or Stolen Passport",
      desc: "Your passport disappeared before your trip. You'll need to file DS-64 and apply for a new passport using DS-11. We guide you through every step and submit on an urgent basis.",
      link: "/passport-services/lost-stolen/",
      linkText: "Learn about Lost/Stolen Passports",
    },
    {
      icon: "ri-user-smile-line",
      title: "Urgent Child Passport",
      desc: "The family trip is coming up and your child's passport expired or was never applied for. Child passports have additional requirements — both parents must consent and the DS-11 must be completed in person. We handle everything after that step.",
      link: "/passport-services/child-passport/",
      linkText: "Learn about Child Passports",
    },
    {
      icon: "ri-file-copy-line",
      title: "Urgent Second Passport",
      desc: "Frequent international traveler who needs a second valid passport — one is tied up in a visa application while you need to travel on another. We process second passport applications on an urgent basis.",
      link: "/passport-services/second-passport/",
      linkText: "Learn about Second Passports",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            What's Your Urgent Passport Situation?
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Urgent passport needs come in different forms. Here's how we handle each one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {situations.map((s, i) => (
            <div key={i} className="bg-[#F7F7F5] rounded-lg p-6 md:p-7 border border-gray-100 flex flex-col">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full mb-4">
                <i className={`${s.icon} text-amber-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-[#2D2D2D] mb-2">{s.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">{s.desc}</p>
              <a
                href={s.link}
                className="whitespace-nowrap inline-flex items-center gap-1.5 text-amber-700 hover:text-amber-800 font-semibold text-sm transition-colors cursor-pointer"
              >
                {s.linkText} <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}